module.exports = __webpack_public_path__ + "assets/crime_black.a45438de.svg";